module.exports = __webpack_public_path__ + "static/footer_logo.0a242a2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/footer_logo.png
// module id = ./src/images/footer_logo.png
// module chunks = 43369700788870 213720915766396 263791100135453